import Request from '../../../../src/core/gd/data/request'
import {DocumentSystemType} from "../../model2/doc/types"

export default class ApiDocument {

    static create(projectId:string, noteTypeId:string, name:string, accessRead:number, accessWrite:number, systemType: DocumentSystemType) {
        return new Request(this, 'POST', 'document/create', {
            projectId   : projectId,
            noteTypeId  : noteTypeId,
            name        : name,
            accessRead  : accessRead,
            accessWrite : accessWrite,
            systemType  : systemType
        })
    }

    static view(documentId:string) {
        return new Request(this, 'GET', 'document/'+documentId+'/view')
    }

    static viewRevision(documentId:string, historyId: string) {
        return new Request(this, 'GET', 'document/'+documentId+'/history/'+historyId)
    }

    static delete(documentId:string) {
        return new Request(this, 'DELETE', 'document/'+documentId+'/delete')
    }

    static update(documentId:string, params:any) {
        return new Request(this, 'PUT', 'document/'+documentId+'/update', params)
    }

    static move(documentId:string, projectId:string) {
        return new Request(this, 'PUT', 'document/'+documentId+'/update', {projectId: projectId})
    }

    static duplicate(documentId:string, projectId:string, name:string) {
        return new Request(this, 'POST', 'document/'+documentId+'/duplicate', {
            projectId       : projectId,
            name            : name
        })
    }

    static saveAsTemplate(documentId:string, name:string, icon:string, description:string) {
        return new Request(this, 'POST', 'document/'+documentId+'/save-as-template', {
            name            : name,
            icon            : icon,
            description     : description,
        })
    }

    static save(documentId:string, params: {
        contentRTF  : any
        cover?      : any
    }) {
        return new Request(this, 'PUT', 'document/'+documentId+'/update', params)
    }

}